const blocks = document.querySelectorAll(
  ".wp-block-adspire-ai-stories-slider"
);

if (blocks.length) {
  import("./view-frontend").then(({ initBlock }) => {
    blocks.forEach((block) => initBlock(block));
  });
}
